import Controller from '@ember/controller';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import type { AppWaldenViewDetailModel } from 'walden-fast/routes/app/walden-view/detail';
import type { FilterValues } from 'walden-fast/types/filters';

export default class AppWaldenViewDetailController extends Controller {
  declare model: AppWaldenViewDetailModel;

  @tracked
  currentFilters: FilterValues | null = null;

  @action
  applyFilters(filters: FilterValues) {
    this.currentFilters = filters;
  }

  get canUseFilters() {
    return !!this.model.userCanAccessFilters;
  }
}
